// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M6 0.698242L10 4.03158V10.8649L15 6.69824L22 12.5316V22H18.5V15H11.5V22H2V4.03158L6 0.698242ZM8 20V4.96833L6 3.30166L4 4.96833V20H8Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M13.5 22V17H16.5V22H13.5Z"}}]};

const City2FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'city-2-filled',
    ref,
    icon: element,
  },
));

City2FilledIcon.displayName = 'City2FilledIcon';

export default City2FilledIcon;
